// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/icon/iconfont.css
// module id = 687
// module chunks = 5